var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.74228e-08 18.0685C3.91405e-08 17.5162 0.447715 17.0685 1 17.0685L19 17.0685C19.5523 17.0685 20 17.5162 20 18.0685C20 18.6208 19.5523 19.0685 19 19.0685L1 19.0685C0.447715 19.0685 1.35705e-07 18.6208 8.74228e-08 18.0685Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9501 11.3802L9.45011 18.9997L7.54979 18.3762L10.0498 10.7567L11.9501 11.3802Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5345 10.5992C19.6335 7.5297 17.4974 4.31496 13.76 3.02744C10.0226 1.73993 6.3598 2.95694 4.54733 5.43616L19.5345 10.5992ZM21.3011 11.2078C21.7311 7.08268 18.9112 2.8982 14.3463 1.3256C9.78137 -0.247004 4.98261 1.31288 2.78064 4.82754C2.46383 5.3332 2.20078 5.87933 1.99992 6.4624L20.9093 12.9766C21.1102 12.3936 21.2393 11.8013 21.3011 11.2078Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7601 3.02748C13.7567 3.02631 13.7373 3.01946 13.6857 3.02422C13.6273 3.02961 13.5227 3.05082 13.369 3.11923C13.0496 3.26139 12.6156 3.56427 12.1149 4.09363C11.3931 4.85673 10.6538 5.96257 10.022 7.32219L14.0599 8.71324C14.3995 7.25296 14.4982 5.92641 14.3995 4.88066C14.3311 4.15524 14.1757 3.64935 14.0116 3.34062C13.9327 3.19204 13.8633 3.11092 13.8206 3.07069C13.7829 3.03518 13.7634 3.0286 13.7601 3.02748ZM15.7699 9.30234C16.7291 5.35953 16.1846 1.9589 14.3463 1.32564C12.5081 0.69237 9.98469 3.03611 8.31196 6.73309C8.0713 7.26498 7.84825 7.82488 7.64738 8.40796L15.2619 11.0312C15.4628 10.4481 15.6319 9.8696 15.7699 9.30234Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResort);
export default __webpack_public_path__ + "static/media/resort.5a783d4db197014f3ddf4496b0107ad4.svg";
export { ForwardRef as ReactComponent };